import { render, staticRenderFns } from "./MyLastActionLogs.vue?vue&type=template&id=6da31ef7"
import script from "./MyLastActionLogs.vue?vue&type=script&lang=js"
export * from "./MyLastActionLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports